import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function FaqAccordion({ faqs, testidPrefix = "faq" }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="space-y-3" data-testid={`${testidPrefix}-list`}>
      {faqs.map((f, i) => {
        const isOpen = open === i;
        return (
          <div
            key={i}
            className={`border bg-card transition-colors duration-300 ${
              isOpen ? "border-amber/50" : "border-white/10"
            }`}
          >
            <button
              data-testid={`${testidPrefix}-question-${i}`}
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="w-full flex items-center justify-between gap-4 text-left px-5 sm:px-6 py-4"
              aria-expanded={isOpen}
            >
              <span className="font-display font-bold uppercase tracking-wide text-base sm:text-lg text-white">
                {f.q}
              </span>
              <ChevronDown
                className={`w-5 h-5 shrink-0 text-amber transition-transform duration-300 ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </button>
            <div
              className={`grid transition-all duration-300 ${
                isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
              }`}
            >
              <div className="overflow-hidden">
                <p
                  data-testid={`${testidPrefix}-answer-${i}`}
                  className="px-5 sm:px-6 pb-5 text-sm sm:text-base text-gray-400 leading-relaxed"
                >
                  {f.a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
